import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';

const SERVICE_URL_USERS = '/usuarios';

const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const SET_ROLES = 'SET_ROLES';
const SET_FAENAS_ROLES = 'SET_FAENAS_ROLES';
const SET_AREAS_ROLES = 'SET_AREAS_ROLES';
const SET_EMPRESAS_ROLES = 'SET_EMPRESAS_ROLES';
const SET_ROLE = 'SET_ROLE';
const LATEST_STATE = 'LATEST_STATE';

// Helper
function axiosConfig() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}


const state = {
    token: localStorage.getItem('token'),
    isLoggedIn: !!localStorage.getItem('token'),
    user: JSON.parse(localStorage.getItem('user')),
    role: JSON.parse(localStorage.getItem('role')),
    roles: JSON.parse(localStorage.getItem('roles')),
    faenasRoles: JSON.parse(localStorage.getItem('faenasRoles')),
    areasRoles: JSON.parse(localStorage.getItem('areasRoles')),
    empresasRoles: JSON.parse(localStorage.getItem('empresasRoles')),
    latest_state: null
};

const getters = {
    token: state => state.token,
    isLoggedIn: state => state.isLoggedIn,
    user: state => state.user,
    roles: state => state.roles,
    faenasRoles: state => state.faenasRoles,
    areasRoles: state => state.areasRoles,
    empresasRoles: state => state.empresasRoles,
    role: state => state.role,
    actualRole: state => state.role && state.role.role,
    latest_state: state => state.latest_state
};

const actions = {
    async checkIsLoggedIn({ commit }) {
        let resp = true;
        try {
            if (localStorage.getItem('token')) {
                // Validar token
                const { data } = await axios.post(`${SERVICE_URL_USERS}/verify-token`, {}, axiosConfig());
                if (data.success) {
                    const jwtUser = VueJwtDecode.decode(data.token);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('user', JSON.stringify(jwtUser));
                    commit(LOGIN, { token: data.token, user: jwtUser });
                } else {
                    resp = false;
                    localStorage.clear();
                    commit(LOGOUT);
                }
            }
        } catch (e) {
            resp = false;
            commit(LOGOUT);
        }
        return resp;
    },

    async loginByToken({ commit }, token) {
        try {
            // Limpiar datos login previo
            localStorage.clear();
            commit(LOGOUT);
            // Verificamos Token
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const response = await axios.post(`${SERVICE_URL_USERS}/verify-token`, {}, config);
            if (!response.data.success) {
                return {
                    success: false,
                    error: 'RUT o contraseña errónea',
                };
            }
            const jwtUser = VueJwtDecode.decode(response.data.token);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(jwtUser));
            commit(LOGIN, { token: response.data.token, user: jwtUser });
            return { success: true };
        } catch {
            return {
                success: false,
                error: 'Lo sentimos, surgió un error. Intente nuevamente',
            };
        }
    },
    async latestState({ commit }, estado) {
        commit(LATEST_STATE, estado);
    },
    // Se mantiene para testeo
    async login({ commit }, creds) {
        try {
            const response = await axios.post(`${SERVICE_URL_USERS}/auth`, creds);
            if (!response.data.success) {
                return {
                    success: false,
                    error: 'RUT o contraseña errónea',
                };
            }
            const jwtUser = VueJwtDecode.decode(response.data.token);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(jwtUser));
            commit(LOGIN, { token: response.data.token, user: jwtUser });
            return { success: true };
        } catch {
            return {
                success: false,
                error: 'Lo sentimos, surgió un error. Intente nuevamente',
            };
        }
    },

    async logout({ commit }) {
        try {
            if (localStorage.getItem('token')) {
                await this.$axios.post(`${SERVICE_URL_USERS}/destroy-token`, {}, axiosConfig());
            }
            var tutorial = localStorage.getItem('tutorial');
            var tutorial_2 = localStorage.getItem('tutorial_2');
            var tutorial_3 = localStorage.getItem('tutorial_3');
            localStorage.clear();
            localStorage.setItem('tutorial', tutorial);
            localStorage.setItem('tutorial_2', tutorial_2);
            localStorage.setItem('tutorial_3', tutorial_3);
            commit(LOGOUT);
        } catch (e) {
            var tutorial = localStorage.getItem('tutorial');
            var tutorial_2 = localStorage.getItem('tutorial_2');
            var tutorial_3 = localStorage.getItem('tutorial_3');
            localStorage.clear();
            localStorage.setItem('tutorial', tutorial);
            localStorage.setItem('tutorial_2', tutorial_2);
            localStorage.setItem('tutorial_3', tutorial_3);
            commit(LOGOUT);
        }
    },

    // Multirroles
    async getRoles({ commit }) {
        try {
            const response = await axios.get(
                `${SERVICE_URL_USERS}/${state.user._id}/permisos-full?module=inventarios`,
                axiosConfig(),
            );
            if (response.data && response.data.permissions && response.data.permissions.length > 0) {
                /*
                -> quita las areas sin permisos
                motivo 1: seleccionar rol lista areas y si estas no traen roles
                          el select de rol se muestra vacio
                motivo 2: toma la primera area si es que hay areas para asignar el primer permiso
                seguro: hace una copia que solo se le asigna cuando se ejecuto el codigo sin problemas
                */
                const permissions = JSON.parse(
                    JSON.stringify(response.data.permissions),
                );

                try {
                    permissions.forEach((permission, iP) => {
                        if (permission.data.areas) {
                            const keys = Object.keys(permission.data.areas);
                            keys.forEach((aId) => {
                                if (permission.data.areas[aId].length === 0) {
                                    delete permissions[iP].data.areas[aId];
                                } // if
                            }); // fE

                            if (Object.keys(permission.data.areas).length === 0) {
                                delete permissions[iP].data.areas;
                            } // if
                        } // if
                    }); // fE

                    response.data.permissions = permissions;
                } catch (e) {
                    console.error(e);
                } // try
                // quitar areas sin permisos fin ->
                localStorage.setItem('roles', JSON.stringify(response.data.permissions));
                commit(SET_ROLES, response.data.permissions);
                localStorage.setItem('faenasRoles', JSON.stringify(response.data.faenas));
                commit(SET_FAENAS_ROLES, response.data.faenas);
                localStorage.setItem('areasRoles', JSON.stringify(response.data.areas));
                commit(SET_AREAS_ROLES, response.data.areas);
                localStorage.setItem('empresasRoles', JSON.stringify(response.data.empresas));
                commit(SET_EMPRESAS_ROLES, response.data.empresas);
                return true;
            }
            return false;
        } catch (e) {
            console.log(e);
            return false;
        }
    },

    async setRole({ commit, state }, role = null) {
        try {
            if (!role) {
                /*
                 * Si no existe un rol previo tomamos el primero
                 * de los posibles para el usuario.
                 */
                if (!state.role) {
                    const firstRole = state.roles[0];
                    let defaultRole = {};
                    defaultRole = {
                        faena_id: firstRole.faena_id,
                        admin: firstRole.data.admin ? firstRole.data.admin : false,
                    };
                    if (!defaultRole.admin) {
                        // Tiene asignado un área - Prioridad
                        if (firstRole.data.areas) {
                            const key = Object.keys(firstRole.data.areas)[0];
                            defaultRole.area_id = key;
                            [defaultRole.role] = firstRole.data.areas[key] || null;
                        } else if (firstRole.data.empresas) {
                            const key = Object.keys(firstRole.data.empresas)[0];
                            defaultRole.empresa_id = key;
                            [defaultRole.role] = firstRole.data.empresas[key] || null;
                        }
                    }
                    localStorage.setItem('role', JSON.stringify(defaultRole));
                    commit('SET_ROLE', defaultRole);
                }
            } else {
                localStorage.setItem('role', JSON.stringify(role));
                commit('SET_ROLE', role);
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    },
};

const mutations = {
    [LOGIN](state, data) {
        state.token = data.token;
        state.user = data.user;
        state.isLoggedIn = true;
    },
    [LOGOUT](state) {
        state.token = null;
        state.user = null;
        state.role = null;
        state.roles = null;
        state.isLoggedIn = false;
    },
    [SET_ROLES](state, roles) {
        state.roles = roles;
    },
    [LATEST_STATE](state, estado) {
        state.latest_state = estado;
    },
    [SET_FAENAS_ROLES](state, faenas) {
        state.faenasRoles = faenas;
    },
    [SET_AREAS_ROLES](state, areas) {
        state.areasRoles = areas;
    },
    [SET_EMPRESAS_ROLES](state, empresas) {
        state.empresasRoles = empresas;
    },
    [SET_ROLE](state, role) {
        state.role = role;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};